import type { SVGProps } from 'react';
const SvgIconCheckTiny = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M11.993 6.587a.75.75 0 0 0-1.06-1.061L7.574 8.63 5.81 7.119a.75.75 0 1 0-1.06 1.06l2.294 2.295a.75.75 0 0 0 1.061 0z"
    />
  </svg>
);
export default SvgIconCheckTiny;
